import { Stack, Text} from '@chakra-ui/react';
import Select from 'react-select';

const QueueSelector = ({queues, ccxQueues, board, tempWidget, setTempWidget, symbeeStats}) => {
    
    const queueSearch = (queues) => {
      let queueSearchArray = [];
      for (var i = 0; i < queues.length; i++) {
          let thisQueue = {};
          thisQueue.value = queues[i]['arn'];
          thisQueue.label = queues[i]['name'];
          queueSearchArray.push(thisQueue);
      }
      return(queueSearchArray);
    };

    
    const handleSelect = (selectedArray) => {
        console.log(selectedArray)
        let newQueueArray = [];
        if(Array.isArray(selectedArray)){
            for ( var i = 0; i < selectedArray.length; i++) {
                newQueueArray.push(selectedArray[i]['value']);
            }
        
        }
        else if(selectedArray?.value){
            newQueueArray.push(selectedArray.value);
        }
        
        let updatedWidgetObject = {...tempWidget};
        updatedWidgetObject["arn"] = newQueueArray;
        setTempWidget(updatedWidgetObject);
    }; 

    const getSelected = (selectedArray, queues) => {
        let newQueueArray = [];
        if(Array.isArray(selectedArray)){
            for ( var i = 0; i < selectedArray.length; i++) {
                for (var q = 0; q < queues.length; q++) {
                    if(queues[q]['arn'] === selectedArray[i]){
                        newQueueArray.push({value: selectedArray[i], label: queues[q]['name'] });
                    }
                }
            }
        }
        
        return newQueueArray;
    };


    return (
        <div style={{height: '40vh'}}>
            <Stack spacing={3} direction='column'>
            <Text>Amazon Connect Queues</Text>
            <Select
                isDisabled={symbeeStats ? getSelected(tempWidget.arn, ccxQueues).length > 0 : false}
                isMulti
                name="Queues"
                defaultValue={getSelected(tempWidget.arn, queues)}
                options={queueSearch(queues)}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={(e) => handleSelect(e)}
            />
            { 
                symbeeStats ?
                    <>
                        <Text>Cornerstone CX Queues</Text>
                        <Select
                            isDisabled={getSelected(tempWidget.arn, queues).length > 0}
                            isMulti
                            name="CCX Queues"
                            defaultValue={getSelected(tempWidget.arn, ccxQueues)}
                            options={queueSearch(ccxQueues)}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={(e) => handleSelect(e)}
                        />
                    </>
                : null
            }
            </Stack>
        </div>
    );
};

export default QueueSelector;


